(() => {
  const dialog = document.getElementById('MirthlyProductSupport');
  if (!dialog) return;
  const title = dialog.querySelector('h2');
  const loading = dialog.querySelector('[role="status"]');
  const frames = {contact:dialog.querySelector('[data-support-contact]')};
  const urls = {contact:'/pages/contact',track:'/apps/17TRACK'};
  const trackPane = dialog.querySelector('[data-support-track]');
  let trackPromise;
  const stylesheet = document.querySelector('link[href*="mirthly-product-support.css"]')?.href;
  const palette = getComputedStyle(document.body);
  let active, opener, previousOverflow;
  const styleFrame = frame => {
    try {
      const doc = frame.contentDocument;
      if (!doc) return;
      doc.documentElement.classList.add('mirthly-support-embedded');
      ['accent','soft','border','canvas'].forEach(key => doc.documentElement.style.setProperty('--support-' + key,palette.getPropertyValue('--product-' + key)));
      if (!doc.querySelector('[data-mirthly-support-style]')) {
        const link = doc.createElement('link');
        link.rel = 'stylesheet';link.href = stylesheet;link.dataset.mirthlySupportStyle = '';doc.head.append(link);
      }
      frame.dataset.ready = 'true';
      if (active === frame) loading.hidden = true;
      doc.addEventListener('keydown', event => {if(event.key === 'Escape') dialog.close();});
      doc.addEventListener('submit',async event => {
        const form = event.target;
        if (!form.matches('#MirthlyContactForm')) return;
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        button.disabled = true;
        try {
          const response = await fetch(form.action,{method:'POST',body:new FormData(form),credentials:'same-origin'});
          const html = await response.text();
          const result = new DOMParser().parseFromString(html,'text/html');
          if (!result.querySelector('.contact-main')) throw new Error('Unable to send');
          frame.srcdoc = html.replace('<head>','<head><base href="'+location.origin+'/pages/contact">');
        } catch (_) {
          button.disabled = false;
          loading.hidden = false;
          loading.textContent = 'Please try again or email mirthlyshop@gmail.com.';
        }
      });
      doc.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!link) return;
        const url = new URL(link.href);
        if (url.origin === location.origin && Object.values(urls).includes(url.pathname)) {
          event.preventDefault();open(url.pathname === urls.contact ? 'contact' : 'track');
        }
      });
    } catch (_) {loading.textContent = 'Please close and try again.';}
  };
  Object.entries(frames).forEach(([key,frame]) => {
    frame.addEventListener('load',()=>styleFrame(frame));
    fetch(urls[key] + '?mirthly_embed=1', {credentials:'same-origin'}).then(response => {if (!response.ok) throw new Error('Unavailable');return response.text();}).then(html => {frame.srcdoc = html.replace('<head>', '<head><base href=' + JSON.stringify(location.origin + urls[key]) + '>');}).catch(() => {loading.textContent = 'Temporarily unavailable. Please try again.';});
  });
  function loadTracking() {
    if (trackPromise) return trackPromise;
    const frame = document.createElement('iframe');
    frame.title = 'Track your order';
    trackPane.replaceChildren(frame);
    trackPromise = fetch(urls.track, {credentials:'same-origin', signal:AbortSignal.timeout(15000)})
      .then(response => {if (!response.ok) throw new Error('Unavailable');return response.text();})
      .then(html => {
        frame.addEventListener('load', () => {
          styleFrame(frame);
          let checks = 0;
          const ready = setInterval(() => {
            const doc = frame.contentDocument;
            if (doc?.querySelector('#yq-tracking-form input, #trackingForm input')) {
              clearInterval(ready);
              trackPane.dataset.ready = 'true';
              if (active === trackPane) loading.hidden = true;
            } else if (++checks >= 60) {
              clearInterval(ready);
              if (active === trackPane) {loading.hidden=false;loading.textContent='Tracking is temporarily unavailable. Please close and try again.';}
              trackPromise = null;
            }
          }, 250);
        }, {once:true});
        const doc = new DOMParser().parseFromString(html,'text/html');
        doc.documentElement.classList.add('mirthly-support-embedded');
        const base = doc.createElement('base');
        base.href = location.origin + urls.track;
        doc.head.prepend(base);
        // The embedded app manages its own form route without changing the product URL.
        const routing = doc.createElement('script');
        routing.textContent = "['replaceState','pushState'].forEach(function(method){var original=history[method].bind(history);history[method]=function(state,title){return original(state,title);};});";
        doc.head.insertBefore(routing, base.nextSibling);
        const link = doc.createElement('link');
        link.rel='stylesheet';link.href=stylesheet;
        doc.head.append(link);
        ['accent','soft','border','canvas'].forEach(key=>doc.documentElement.style.setProperty('--support-'+key,palette.getPropertyValue('--product-'+key)));
        frame.srcdoc = '<!doctype html>' + doc.documentElement.outerHTML;
      }).catch(() => {
        trackPromise=null;
        if(active===trackPane){loading.hidden=false;loading.textContent='Tracking is temporarily unavailable. Please close and try again.';}
      });
    return trackPromise;
  }
  function open(key, link) {
    active = key === 'track' ? trackPane : frames[key];
    trackPane.hidden = active !== trackPane;
    if(key === 'track') loadTracking();
    title.textContent = key === 'contact' ? 'CONTACT' : 'TRACK YOUR ORDER';
    Object.values(frames).forEach(frame => frame.hidden = frame !== active);
    loading.textContent = 'Loading…';
    loading.hidden = active.dataset.ready === 'true';
    if (!dialog.open) {
      opener = link || document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
    }
  }
  document.addEventListener('click',event => {
    const link = event.target.closest('a[href]');
    if (!link || dialog.contains(link)) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin || !Object.values(urls).includes(url.pathname)) return;
    event.preventDefault();event.stopImmediatePropagation();
    open(url.pathname === urls.contact ? 'contact' : 'track',link);
  },true);
  dialog.querySelector('[data-support-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target === dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('close',()=>{document.documentElement.style.overflow=previousOverflow;opener?.focus();});
})();




